import styled from 'styled-components';
import differentialBackground from '../../../assets/images/differential-background.png';

export const SectionContainer = styled.section`
  min-height: 600px;
  width: 100%;
  background-color: #000;
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(54, 54, 54, 0.18)), url(${differentialBackground});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: scroll;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 4rem 0;
  
  @media (max-width: 768px) {
    min-height: auto;
    padding: 3rem 0;
  }
  
  @media (max-width: 480px) {
    padding: 2.5rem 0;
  }
`;

export const ContentContainer = styled.div`
  max-width: 800px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 2rem;
  position: relative;
  padding-top: 70px;
  
  @media (max-width: 768px) {
    padding: 60px 1.5rem 0;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    padding: 50px 1rem 0;
  }
`;

export const LogoContainer = styled.div`
  position: absolute;
  top: 0;
  margin-bottom: 2rem;
  
  img {
    height: 50px;
    filter: brightness(0) invert(1);
  }
  
  @media (max-width: 768px) {
    position: relative;
    margin-bottom: 1.5rem;
    
    img {
      height: 45px;
    }
  }
  
  @media (max-width: 480px) {
    margin-bottom: 1rem;
    
    img {
      height: 40px;
    }
  }
`;

export const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 1.3;
  margin-bottom: 2rem;
  color: #fff;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 1.6rem;
    margin-bottom: 1.2rem;
    line-height: 1.4;
  }
`;

export const Description = styled.p`
  font-size: 1.1rem;
  font-weight: 300;
  line-height: 1.6;
  color: #fff;
  opacity: 0.9;
  max-width: 700px;
  width: 100%;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.7;
    max-width: 100%;
  }
  
  @media (max-width: 480px) {
    font-size: 0.95rem;
    line-height: 1.8;
  }
`;